import React, { useMemo } from 'react';
import Slider from 'react-slick';
import { browserHistory } from 'react-router';

import CarouselCard from '../CarouselCard';

import styles from './CommunityCarousel.module.scss';
import './slick.scss'; // react-slick stylings

//React-Slick Settings
const slickSettings = {
  dots: true,
  className: styles.carouselContent,
  infinite: false,
  slidesToShow: 1,
  slidesToScroll: 1,
  speed: 500,
  variableWidth: true,
  focusOnSelect: true,
  arrows: true
};

const EventsCard = ({ count, baseRoute }) => (
  <CarouselCard
    contentExists
    type="event"
    title="Events & Services"
    addButtonCopy="Add event"
    existsButtonCopy={`View ${count} upcoming event${count === 1 ? '' : 's'}`}
    existsButtonAction={() => browserHistory.push(`${baseRoute}/event-details`)}
  />
);
const LiveStreamCard = ({ baseRoute }) => (
  <CarouselCard
    contentExists
    type="liveStream"
    title="Live Stream"
    existsButtonCopy="View livestreams"
    existsButtonAction={() => browserHistory.push(`${baseRoute}/event-details`)}
  />
);
const DonationCard = ({ count, baseRoute }) => (
  <CarouselCard
    contentExists
    type="donation"
    title="Donations"
    existsButtonCopy={`See ${count} organization${count === 1 ? '' : 's'}`}
    existsButtonAction={() => browserHistory.push(`${baseRoute}/donations`)}
  />
);
const ObituaryCard = ({ baseRoute }) => (
  <CarouselCard
    contentExists
    type="obituary"
    title="Obituary"
    existsButtonCopy="Read Obituary"
    existsButtonAction={() => browserHistory.push(`${baseRoute}/obituary`)}
  />
);

const FacebookShareCard = ({ shareUrl }) => (
  <CarouselCard {...{ shareUrl }} contentExists type="facebookShare" title="Share to Facebook" />
);

const CommunityCarousel = ({ donations, eventsArray, obituary, baseRoute, shareUrl }) => {
  const cardsToRender = useMemo(() => {
    const cardArray = [];

    // for now, only display cards if the respective content exists
    if (eventsArray?.length) {
      cardArray.push(
        <EventsCard count={eventsArray?.length} {...{ baseRoute }} key={'eventCard'} />
      );
    }
    if (eventsArray?.length && eventsArray?.some(event => !!event.videoStreamUrl)) {
      cardArray.push(<LiveStreamCard {...{ baseRoute }} key={'liveStreamCard'} />);
    }
    if (donations?.length) {
      cardArray.push(
        <DonationCard count={donations?.length} {...{ baseRoute }} key={'donationCard'} />
      );
    }
    if (!!obituary) {
      cardArray.push(<ObituaryCard {...{ baseRoute }} key={'obitCard'} />);
    }

    cardArray.push(<FacebookShareCard {...{ shareUrl }} key={'facebookShareCard'} />);

    return cardArray;
  }, [donations, eventsArray, obituary]);

  // if there are no cards, do not show the carousel
  return cardsToRender?.length ? (
    <div className={styles.communityCarousel}>
      <Slider {...slickSettings}>{cardsToRender.map(c => c)}</Slider>
    </div>
  ) : (
    ''
  );
};

export default CommunityCarousel;
